import { defineStore } from 'pinia'

export const useTextFilterStore = defineStore('TextFilterStore', {
  state: () => {
    return {
      q: '',
      dirty: false,
    }
  },
  getters: {
    asObject: (state) => {
      if (state.q === '') {
        return {
          q: null,
        }
      }

      return { q: state.q }
    },

    filter: (state) => {
      if (state.q === '') {
        return null
      }

      return state.q
    },
  },
  actions: {
    isDirty: (_name: string) => {
      return this && this.dirty
    },

    setSelectedOption(_: string, value: string) {
      this.$patch({
        dirty: true,
        q: value || '',
      })
    },
  },
})
